<template>
  <v-input :value="value" :rules="rules">
    <label v-if="value === undefined" style="position:absolute;top:0;left:0;">{{ label }}</label>
    <label v-else style="position:absolute;top:0;left:0;color:rgba(0, 0, 0, 0.67);font-weight: 400;font-size: 12px;">{{ label }}</label>
    <div style="margin-top:22px">
      <div>
        <v-img
          v-if="value !== undefined"
          max-height="40"
          min-height="40"
          max-width="40"
          min-width="40"
          style="margin: 5px; cursor: pointer;"
          :src="value"
          contain
          @click="previewDialog = true"
        ></v-img>
      </div>
      <div>
        <template v-if="value === undefined">
          <v-btn @click="showPicker = true" color="success" small>
            {{ $t("globals.add") }}
          </v-btn>
        </template>
        <template v-else>
          <v-btn @click="showPicker = true" color="primary" small>
            {{ $t("components.portal.image_picker.change") }}
          </v-btn>
          <v-btn
            @click="$emit('update:value', undefined)"
            text
            color="error"
            small
          >
            {{ $t("globals.remove") }}
          </v-btn>
        </template>
      </div>
      <v-dialog v-model="showPicker" scrollable persistent max-width="800">
        <material-card
          :title="$t('components.portal.image_picker.upload_file')"
          icon="toggle_on"
          :color="$vuetify.theme.themes.light.success"
        >
          <v-card-text>
            <image-uploader
              v-if="showPicker"
              v-on:upload-started="onUploadStarted"
              v-on:upload-error="onUploadError"
              v-on:upload-completed="onUploadCompleted($event)"
            ></image-uploader>
          </v-card-text>
          <v-card-actions>
            <v-btn
              :loading="uploading"
              text
              @click="
                showPicker = false;
                selectedImage = undefined;
              "
            >
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn
              :loading="uploading"
              :disabled="!selectedImage"
              color="primary"
              @click="
                $emit('update:value', selectedImage);
                showPicker = false;
                selectedImage = undefined;
              "
            >
              {{ $t("globals.save") }}
            </v-btn>
            
          </v-card-actions>
        </material-card>
      </v-dialog>
      <v-dialog v-model="previewDialog" scrollable persistent max-width="880">
        <material-card
          :title="label"
          icon="image"
          :color="$vuetify.theme.themes.light.primary"
        >
          <v-card-text>
            <v-img
              v-if="value !== undefined"
              max-height="770"
              min-height="770"
              max-width="770"
              min-width="770"
              style="margin: 5px"
              :src="value"
              contain
            ></v-img>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="previewDialog = false">
              {{ $t("globals.close") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
    </div>
  </v-input>
</template>

<script>
import ImageUploader from "./ImageUploader";
export default {
  components: {
    ImageUploader,
  },
  props: ["value", "rules", "label"],
  data: () => ({
    selectedImage: undefined,
    showPicker: false,
    fileBase64: undefined,
    uploading: false,
    previewDialog: false,
  }),
  methods: {
    onUploadCompleted(res) {
      // console.log(res);
      this.uploading = false;
      this.snackbar = true;
      this.selectedImage = res[0].Name;
    },
    onUploadStarted() {
      this.uploading = true;
    },
    onUploadError() {
      this.uploading = false;
    },
  },
};
</script>
